import { useEffect } from "react";

/** Subscribe to draft overrides pushed via window.postMessage from the CMS editor. */
export function useCmsPreviewBridge() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    (window as any).__cmsDraftOverrides ??= {};
    const onMessage = (e: MessageEvent) => {
      const d = e.data;
      if (!d || typeof d !== "object" || d.type !== "cms-preview") return;
      if (d.action === "set") {
        (window as any).__cmsDraftOverrides = d.overrides ?? {};
      } else if (d.action === "clear") {
        (window as any).__cmsDraftOverrides = {};
      }
      window.dispatchEvent(new Event("cms-preview-update"));
    };
    window.addEventListener("message", onMessage);
    // Announce readiness so the parent can re-send the current draft
    try { window.parent?.postMessage({ type: "cms-preview", action: "ready" }, "*"); } catch {}
    return () => window.removeEventListener("message", onMessage);
  }, []);
}
